/** Rendered by the auth interface without the shell; both gates key on it. */
export const OAUTH_CONSENT_PATH = '/oauth/authorize';
